import { render, staticRenderFns } from "./TabGeneralComponent.vue?vue&type=template&id=ec6ea608&scoped=true"
import script from "./TabGeneralComponent.vue?vue&type=script&lang=js"
export * from "./TabGeneralComponent.vue?vue&type=script&lang=js"
import style0 from "./TabGeneralComponent.vue?vue&type=style&index=0&id=ec6ea608&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec6ea608",
  null
  
)

export default component.exports